import { render, staticRenderFns } from "./gear_reward.vue?vue&type=template&id=261afab4&scoped=true"
import script from "./gear_reward.vue?vue&type=script&lang=js"
export * from "./gear_reward.vue?vue&type=script&lang=js"
import style0 from "./gear_reward.vue?vue&type=style&index=0&id=261afab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261afab4",
  null
  
)

export default component.exports